import { mapApiTexturasToMaterialFields } from '@utils/sceneObjects/resolvePbrMaterial'

export type BackAcabadosInfo = {
  idTexturas: number
  identificadorTextura: number
  idGruposDeTexturas: number
  nombre: string
  descripcion: string
  complementos?: string
  nombreFichero?: string
  ruta?: string
  url: string
  urlMiniatura?: string
  factorRepeticionX: number
  factorRepeticionY: number
  opacidad: number
  reflejo: number
  rugosidad: number
  color?: string
  metal: number
  brillo: number
  espejo: boolean
  miniatura?: string
  rugosidadFichero?: string
  factorDeEscala?: number
  descatalogado?: boolean
  idDependencias?: string | number
  grupo?: string | number
  orientacionTextura?: number
  desplazamiento?: number
  zone?: string
}

export default function getStandardMaterial(
  material: BackAcabadosInfo,
  acabado?: string,
  modelo?: string,
) {
  const pbr = mapApiTexturasToMaterialFields(material)

  return {
    color: pbr.color,
    groupID: material?.idGruposDeTexturas,
    searchID: material?.idTexturas,
    id: material?.identificadorTextura,
    description: material?.descripcion,
    url: material?.url,
    repeatX: pbr.repeatX,
    repeatY: pbr.repeatY,
    name: material?.nombre,
    mirror: pbr.mirror,
    roughness: pbr.roughness,
    displacementScale: pbr.displacementScale,
    img: material?.miniatura,
    bumpMap: pbr.bumpMap,
    displacement: pbr.displacement,
    envMapIntensity: pbr.envMapIntensity,
    metalness: pbr.metalness,
    bumpScale: pbr.bumpScale,
    opacity: pbr.opacity,
    textureRotation: pbr.textureRotation,
    acabado,
    modelo,
    complemento: material?.complementos,
  }
}
export type _Material = ReturnType<typeof getStandardMaterial>
